import { render, staticRenderFns } from "./TimelineDetails.vue?vue&type=template&id=2d15f854&"
import script from "./TimelineDetails.vue?vue&type=script&lang=ts&"
export * from "./TimelineDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports